import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { tokenNotExpired } from 'angular2-jwt';
import { AccountService } from '../../service/account/account.service';

import { WebService } from '../web.service';

@Injectable()
export class LoginService extends WebService {

    public user;

    // constructor( private accountService: AccountService ) {
    // }

    // canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    //     if ( tokenNotExpired() ) {
    //         return true;
    //     }
    //     if ( state.url === '/login' && tokenNotExpired() ) {
    //         this.router.navigate(['/pages/dashboard']);
    //         return false;
    //     }
    //     this.router.navigate(['/login']);
    //     return false;
    // }

    loggedIn() {
      return tokenNotExpired();
    }

    logout() {
        localStorage.removeItem('token');
        // Notifica a otras pestañas que el usuario ha cerrado sesión
        localStorage.setItem('logoutEvent', Date.now().toString());
        localStorage.removeItem('profile');
        localStorage.removeItem('permissions');
        this.refreshToken();
        this.router.navigateByUrl('/login');
    }

    login(body: Object): Observable<Response> {
        this.refreshToken();
        return this.http.post( `${this.apiUrl}/auth/login`, JSON.stringify(body), { headers: this.headers } );
    }

    passwordRecovery(body: Object): Observable<Response> {
        return this.http.post( `${this.apiUrl}/auth/password_recovery`, JSON.stringify(body), { headers: this.headers } );
    }

    setUser(user) {
        this.user = user;
    }

    getUser() {
        return this.user;
    }
    getRole(){
        return JSON.parse(localStorage.getItem('profile')).roles[0].name;//.id
    }
    isEmployeeUser() {
        let user=JSON.parse(localStorage.getItem('profile'));
        if(user)
        {
            if(user.employee_id)
                return true;
        }        
        return false;    
    }
    isEmployeeUserOnLine():Observable<boolean>{
        return this.http.get( `${this.apiUrl}/profile/is-user-employee`, { headers: this.headers } ).map(response => response.ok);
    }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/service/login/login.service.ts